import { render, staticRenderFns } from "./ReferralFollowupForm.vue?vue&type=template&id=6c0cafce&scoped=true&"
import script from "./ReferralFollowupForm.vue?vue&type=script&lang=ts&"
export * from "./ReferralFollowupForm.vue?vue&type=script&lang=ts&"
import style0 from "./ReferralFollowupForm.vue?vue&type=style&index=0&id=6c0cafce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0cafce",
  null
  
)

export default component.exports